var _defs, _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBanner(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1653488621171,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 888,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "@font-face { font-family: feedback-iconfont; src: url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff2?t=1630033759944\") format(\"woff2\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.woff?t=1630033759944\") format(\"woff\"), url(\"//at.alicdn.com/t/font_1031158_u69w8yhxdu.ttf?t=1630033759944\") format(\"truetype\"); }\n"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M127.905952 834.398237c-42.886113 0-76.743571-33.857458-76.743571-75.238795V188.849375h844.931667c42.133725 0 76.743571 33.857458 76.743571 75.238795v492.814108c0 13.542983 11.285819 24.828802 25.581191 24.828802s25.58119-11.285819 25.58119-24.828802V264.08817c0-69.219691-57.181484-125.648788-127.905952-125.648787H0V758.407054c0 69.219691 57.181484 125.648788 127.905952 125.648787h783.235855c14.295371 0 25.58119-11.285819 25.581191-24.828802 0-13.542983-11.285819-24.828802-25.581191-24.828802H127.905952z",
    "p-id": 889
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M564.290963 682.415871c19.562087 0 34.609846 15.800147 34.609845 34.609845 0 19.562087-15.800147 34.609846-34.609845 34.609846-19.562087 0-34.609846-15.800147-34.609846-34.609846s15.047759-34.609846 34.609846-34.609845z",
    "p-id": 890
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M457.451874 717.778104m-34.609846 0a34.609846 34.609846 0 1 0 69.219691 0 34.609846 34.609846 0 1 0-69.219691 0Z",
    "p-id": 891
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M351.365173 717.778104m-34.609846 0a34.609846 34.609846 0 1 0 69.219691 0 34.609846 34.609846 0 1 0-69.219691 0Z",
    "p-id": 892
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M672.634827 682.415871c19.562087 0 34.609846 15.800147 34.609846 34.609845 0 19.562087-15.800147 34.609846-34.609846 34.609846-19.562087 0-34.609846-15.800147-34.609845-34.609846-0.752388-18.809699 15.047759-34.609846 34.609845-34.609845z",
    "p-id": 893
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.a8fa9d1b.svg";
export { ForwardRef as ReactComponent };